export default __webpack_public_path__ + "static/media/reset.5b5d4555.svg";